import { Button, Code, Stack } from '@mantine/core';
import type { RowData } from '@tanstack/react-table';
import isEqual from 'lodash-es/isEqual';

import { FiltersList } from '@apple/ui/data-table/controls/filters-list';
import type { DataTableInstance } from '@apple/ui/data-table/features';
import { useHeaderIsFixed } from '@apple/ui/shell/contexts/header';

export function TableFilters<TRow extends RowData>({
	table,
	clearLabel,
	debug,
}: {
	table: DataTableInstance<TRow>;
	clearLabel: string;
	debug: boolean;
}) {
	const isDirty = !isEqual(table.state.columnFilters, table.initialState.columnFilters);
	const { isFixed } = useHeaderIsFixed();
	return (
		<Stack h='100%' p={0} m={0} gap={0}>
			<Stack px='xs'>
				<FiltersList
					headers={table.getFlatHeaders()}
					variant={isFixed ? 'column' : 'row'}
				/>
				<Button disabled={!isDirty} onClick={() => table.resetColumnFilters()}>
					{clearLabel}
				</Button>
				{debug && <Code block>{JSON.stringify(table.state, null, 2)}</Code>}
			</Stack>
		</Stack>
	);
}
